import '../../../src/main.css';
import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { Input } from 'antd';
import StatusFilter from 'modules/my_tickets/StatusFilter';
import ReactDatePicker from 'react-datepicker';
const { Search } = Input;

function CustomerComplaintTikcetFilter({selectedStatus, setSelectedStatus, handleFilterClick, handleSearch,  handleAgentSearch, setStartDate, setEndDate, startDate, endDate}) {
    const [show, setShow] = useState(false);
	const handleClose = () => setShow(false);
	const handleShow = () => setShow(true);
	const [agent, setAgent] = useState('');

    const handleClickFilter = () => {
		handleFilterClick();
		setShow(false);
	};


	const onRangeChange = (dates, dateStrings) => {
		const [start, end] = dates;
		setStartDate(start);
		setEndDate(end);
	};

	const handleAgentChange = (e) => {
		setAgent(e.target.value);
		handleAgentSearch(e.target.value);
	  };

	return (
		<>
			<div className='d-flex justify-content-end gap-2 w-50 float-end my-3'>
				<Search
                    style={{width:'75%'}}
					addonBefore='Search'
					placeholder='Search orders by order Id/email /phone number'
					onSearch={handleSearch}
					allowClear
				/>
				<Button
					onClick={handleShow}
					className='flex-fill'>
					+ More Filter
				</Button>
			</div>
			<Offcanvas
				show={show}
				style={{ width: '35vw' }}
				onHide={handleClose}
				name={'Filter & Download'}
				placement={'end'}>
				<Offcanvas.Header closeButton>
					<Offcanvas.Title>
						<h2>Filter By</h2>
					</Offcanvas.Title>
				</Offcanvas.Header>
				<Offcanvas.Body >
					<div className='d-flex flex-column align-items-center gap-2'>
						<ReactDatePicker
							popperPlacement='bottom-start'
							selected={startDate}
							onChange={onRangeChange}
							startDate={startDate}
							formatWeekDay={day => day.slice(0, 3)}
							endDate={endDate}
							selectsRange
							dateFormat="MMM dd"
							className='form-control'
						/>
                        <StatusFilter selectedStatus={selectedStatus} setSelectedStatus={setSelectedStatus}/>
						<Input
							placeholder='Search by Agent'
							value={agent}
							onChange={handleAgentChange}
							style={{ width: '100%' }}
						/>
						{/* <CategoryFilter
							selectedCategory={selectedCategory}
							setSelectedCategory={setSelectedCategory}
						/>
						<SubCategoryFilter
							selectedCategory={selectedCategory}
							selectedSubCategory={selectedSubCategory}
							setSelectedSubCategory={setSelectedSubCategory}
						/> */}
						<Button
							variant='primary'
							style={{ width: '100%' }}
							onClick={handleClickFilter}>
							Filter
						</Button>
					</div>
				</Offcanvas.Body>
			</Offcanvas>
		</>
	);
}

export default CustomerComplaintTikcetFilter;
